package one.healthium.onboarding.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.onboarding.domain.configs.RelateToStatementScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.components.RelateToStatementContent

interface RelateToStatementEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun RelateToStatementScreen(
    eventDelegate: RelateToStatementEventDelegate,
    profileKey: String,
    screenConfig: RelateToStatementScreenConfig,
) {
    UserDataProvider { userState, contract ->
        RelateToStatementScreenContent(
            profileKey = profileKey,
            screenConfig = screenConfig,
            userState = userState,
            onOptionChanged = { contract.onRelateToStatementChanged(profileKey, it) },
            onNextClicked = eventDelegate::onNextClicked,
        )
    }
}

@Composable
private fun RelateToStatementScreenContent(
    modifier: Modifier = Modifier,
    profileKey: String,
    screenConfig: RelateToStatementScreenConfig,
    userState: UserProfileUiModel,
    onOptionChanged: (Int) -> Unit,
    onNextClicked: () -> Unit,
) {
    RelateToStatementContent(
        modifier = modifier,
        screenConfig = screenConfig,
        userState = userState,
        selectedOption = userState.statements[profileKey],
        onOptionChanged = onOptionChanged,
        onNextClicked = onNextClicked,
    )
}